<template>
  <div class="vd-gl-content">
    <a-row class="vd-toolbar">
      <a-col>
        <a-form layout="inline">
          <a-form-item>
            <a-button-group>
              <a-button
                :type="this.isMy === 1 ? 'primary' : ''"
                @click="changeMy(1)"
                >由我创建</a-button
              >
              <a-button
                :type="this.isMy === 0 ? 'primary' : ''"
                @click="changeMy(0)"
                >他人创建</a-button
              >
            </a-button-group>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
    <a-table
      row-key="id"
      :data-source="list"
      :pagination="pagination"
      :loading="loading"
    >
      <a-table-column title="id" data-index="id" />
      <a-table-column title="资料名称" data-index="name" />
      <a-table-column title="过期时间" data-index="due_time" />
      <a-table-column title="状态" data-index="status" />
    </a-table>
  </div>
</template>

<script>
import { get_package_list } from '@/api/book'

export default {
  name: 'Package',
  data() {
    return {
      isMy: 1,
      loading: false,
      list: [],
      pagination: {
        total: 1,
        current: 1,
        pageSize: 10,
        hideOnSinglePage: true,
        onChange: (page) => {
          this.pagination.current = page
        },
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    changeMy(type) {
      this.isMy = type
      this.getData()
    },
    getData() {
      this.loading = true
      get_package_list({
        isMy: this.isMy,
        current: this.pagination.current,
        pageSize: this.pagination.pageSize,
      }).then((res) => {
        this.loading = false
        if (res.code === 1) {
          this.list = res.list
          this.total = res.total
        }
      })
    },
  },
}
</script>

<style scoped></style>
